import React, { useEffect, useState } from 'react';
import Header from '../Component/Header';
import Footer from '../Component/Footer';
import { API_BASE } from "../api/apiConfig";

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  // Dummy API fetch
  useEffect(() => {
    fetch('https://jsonplaceholder.typicode.com/posts?_limit=6') // Only 6 blogs
      .then((res) => res.json())
      .then((data) => {
        setBlogs(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching blog data:', error);
        setLoading(false);
      });
  }, []);

  return (
    <>
      <Header />
      <main className="min-h-screen bg-[#0F172A]">
   <section className="relative overflow-hidden bg-gradient-to-b from-[#0F172A] to-[#1E293B] py-20 md:py-28">
        <div className="absolute inset-0 z-0 opacity-20">
            <img alt="Background pattern" decoding="async" data-nimg="fill" className="object-cover" src="/diagonal-pattern.png" />
        </div>
        <div className="container relative z-10 mx-auto px-4 text-center md:px-6">
            <div className="mx-auto max-w-3xl">
                <h1 className="mb-6 text-4xl font-bold tracking-tight text-white md:text-5xl lg:text-6xl">Explore Insights & Stories from Our <span className="text-primary">Travel Experts</span> </h1>
                <p className="mb-8 text-lg text-gray-300 md:text-xl">      Discover expert-written blogs, travel guides, and stories that inspire your next adventure.</p>
            </div>
        </div>
    </section>

        {/* Blog Section */}
        <div className="relative w-full bg-slate-50 py-12 md:py-24">
          <div className="text-center mb-12">
            {/* Tag + Title */}
            <div className="border mb-3 inline-flex items-center rounded-full bg-primary/10 px-3 py-1 text-xs font-medium text-primary cursor-pointer">
              <svg className="lucide lucide-globe mr-1 h-3 w-3"/>
              Blog
            </div>
            <h2 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl mb-4">
              Our latest <span className="text-primary">blog</span>
            </h2>
            <p className="text-slate-600 max-w-2xl mx-auto">
              Discover inspiring destinations that match your travel style.
            </p>
          </div>

          <div className="container mx-auto px-4 md:px-6">
            <div className="mt-12 grid gap-4 md:gap-6 lg:grid-cols-4 sm:grid-cols-2 justify-center">
              {loading ? (
                <p className="text-center col-span-full">Loading blogs...</p>
              ) : (
                blogs.map((blog) => (
                  <div key={blog.id} className="snap-start">
                    <div className="group relative overflow-hidden rounded-2xl bg-white shadow-xl transition-all duration-500 hover-lift h-full border border-slate-100 cursor-pointer">
                      <div className="relative h-40 md:h-64 w-full overflow-hidden">
                        <img
                          src={`https://source.unsplash.com/random/300x200?sig=${blog.id}`} // Random blog image
                          alt="blog"
                          className="object-cover transition-transform duration-700 group-hover:scale-110 h-full w-full"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent transition-opacity duration-300 group-hover:opacity-70" />
                      </div>
                      <div className="p-2 md:p-5">
                        <h3 className="text-base md:text-2xl font-bold mb-2 md:mb-3 group-hover:text-primary/90 transition-colors duration-300 line-clamp-2">
                          {blog.title}
                        </h3>
                        <div className="flex items-center justify-between mb-2 md:mb-3">
                          <p className="text-xs text-slate-500">By Admin</p>
                          <p className="text-xs text-slate-500">June 2025</p>
                        </div>
                        <div className="text-xs md:text-sm text-slate-600 line-clamp-2">
                          {blog.body}
                        </div>
                        <div className="flex items-center justify-between mt-3">
                          <div className="text-xs md:text-sm text-primary font-medium group-hover:underline flex items-center cursor-pointer">
                            Read More
                            <svg className="lucide lucide-arrow-right inline h-3 w-3 md:h-3.5 md:w-3.5 ml-1 group-hover:translate-x-1 transition-transform duration-300"/>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default Blog;
